import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import { Label } from "./Label";

const RequiredMark = () => (
  <Box component="span" sx={{ color: "error.main", ml: 0.25 }}>
    *
  </Box>
);

export const FormField = ({ label, htmlFor, required, error, aside, children }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, flex: 1, minWidth: 0 }}>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 1 }}>
      <Label htmlFor={htmlFor}>
        {label}
        {required && <RequiredMark />}
      </Label>
      {aside}
    </Box>
    {children}
    {error && (
      <Typography variant="caption" sx={{ color: "error.main", fontSize: "0.75rem" }}>
        {error}
      </Typography>
    )}
  </Box>
);

FormField.propTypes = {
  label: PropTypes.node.isRequired,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  aside: PropTypes.node,
  children: PropTypes.node,
};
